import { useMemo } from 'react';

import { useGameConfig } from '../../../config/GameConfigProvider';
import { useSettingsSlice } from '../../../store/slices/settings/selectors';
import type { UseAnyDictionaryService } from '../../dictionary/reactBindings/types';
import type { DictionaryServiceOptions } from '../../dictionary/types';

import { useUITranslationService } from './hooks';

export const useUITranslationServiceConnected = (): ReturnType<UseAnyDictionaryService> => {
  const languageHandle = useSettingsSlice.getLanguageHandle();
  const {
    config: { translationConfig },
  } = useGameConfig();

  const options: DictionaryServiceOptions = useMemo(() => {
    return {
      keyMap: translationConfig?.uiDictionaryMap,
    };
  }, [translationConfig]);

  return useUITranslationService(languageHandle, translationConfig.uiFiles ?? [], options);
};
